import React, { useState, useEffect } from 'react'
import axios from 'axios'
import './BuscaProcesso.css'

const mediaWeb = window.matchMedia("(min-width:600px)").matches

const converterData = (data) => {
    const [ano, mes, dia] = data.split("-")
    const dataFormatada = `${dia}/${mes}/${ano}`
    return dataFormatada
}

const BuscaProcesso = () => {
    const [processos, setProcessos] = useState([])
    const [filtros, setFiltros] = useState([])
    const [loading, setLoading] = useState(false)
    const [users, setUsers] = useState([])

    const fetchProcessos = async (filtros) => {
        setLoading(true)
        try {
            // Converte cada filtro para string JSON
            const params = {
                filtros: filtros.map(filtro => JSON.stringify({ tipo: filtro.tipo, opcao: filtro.opcao }))
            }

            const response = await axios.get('/api/juridico/buscaProcesso', { params })
            setProcessos(response.data)
        } catch (error) {
            alert(error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchProcessos(filtros)
    }, [filtros])

    const addQtdFiltros = (e) => {
        e.persist()
        setFiltros(prevFiltros => {
            if (e.target.name === "mais") return [...prevFiltros, { tipo: "", opcao: "" }]
            return prevFiltros.length > 1 ? prevFiltros.slice(0, -1) : prevFiltros
        })
    }

    const updateFiltro = (index, tipo) => {
        const updatedFiltros = [...filtros]
        updatedFiltros[index] = { ...updatedFiltros[index], tipo, opcao: "" }
        setFiltros(updatedFiltros)
    }

    let debounceTimeout

    const updateFiltroOpcao = (index, opcao) => {
        // Atualiza diretamente sem debounce (pode ser acrescentado se necessário)
        const updatedFiltros = [...filtros]
        updatedFiltros[index].opcao = opcao
        setFiltros(updatedFiltros)
    }

    useEffect(() => {
        axios('/api/userJuridico/getAdvogados')
            .then(res => setUsers(res.data))
            .catch(error => alert(error.response.message))

        axios.get('/api/juridico/buscaProcessoAll')
            .then(res => setProcessos(res.data))
            .catch(error => alert(error.response.message))
    }, [])

    const excluirProcesso = (idProcesso) => {
        console.log(idProcesso)
        axios.post('/api/juridico/excluirProcesso', { id: idProcesso })
            .then(res => {
                alert(res.data.message)
                window.location = "/juridico/buscaProcesso"
            })
            .catch(error => console.log(error.response.data.message))
    }

    return (
        <>
            <div style={{ margin: "1vw 0 0 1vw", textAlign: "left" }}>
                <button style={{
                    width: mediaWeb ? "4vw" : "10vw",
                    backgroundColor: "#E90303", color: "#FFFF",
                    border: "none", borderRadius: "5px"
                }}
                    name="menos"
                    onClick={(e) => addQtdFiltros(e)}>-</button>
                <input style={{
                    marginLeft: "0.5vw", marginRight: "0.5vw", width: mediaWeb ? "4vw" : "10vw",
                    borderRadius: "5px", backgroundColor: "#00000000", textAlign: "center"
                }} value={filtros.length} disabled />
                <button style={{
                    width: mediaWeb ? "4vw" : "10vw", marginRight: "0.5vw",
                    backgroundColor: "#42A908", color: "#FFFF",
                    border: "none", borderRadius: "5px"
                }}
                    name="mais"
                    onClick={(e) => addQtdFiltros(e)}>+</button>

                {filtros.map((filtro, index) => (
                    <div key={index} style={{ marginTop: "2vh" }}>
                        <select className="input" style={{ marginRight: mediaWeb ? "1vw" : "5vw" }}
                            name="filtro"
                            onChange={(e) => updateFiltro(index, e.target.value)} >
                            <option value=""></option>
                            <option value="Tipo">Classificação</option>
                            <option value="Número">Número</option>
                            <option value="Responsável">Responsável</option>
                            <option value="Portaria">Portaria</option>
                            <option value="Pessoas">Pessoas</option>
                            <option value="Situação">Situação</option>
                            <option value="Data">Data (Mês/Ano)</option>
                            <option value="Interessados">Interessados</option>
                        </select>

                        {filtro.tipo === "Tipo" ? (
                            <select className="input" style={{ width: mediaWeb ? "20vw" : "50vw" }}
                                name="filtroOpcao"
                                onChange={(e) => updateFiltroOpcao(index, e.target.value)} >
                                <option value=""></option>
                                <option value="Violação de Prerrogativas">Violação de Prerrogativas</option>
                                <option value="Cobrança">Cobrança</option>
                                <option value="Inscrição Profissional">Inscrição Profissional</option>
                                <option value="Registro de Empresas">Registro de Empresas</option>
                                <option value="Arrecadação">Arrecadação</option>
                                <option value="Licitação e contratos">Licitação e contratos</option>
                                <option value="Outros">Outros</option>
                            </select>
                        ) : filtro.tipo === "Responsável" ? (
                            <select className='input' style={{ width: mediaWeb ? "20vw" : "50vw" }}
                                name="filtroOpcao"
                                onChange={(e) => updateFiltroOpcao(index, e.target.value)} >
                                <option value="" disabled selected></option>
                                {users.map(el => (
                                    <option key={el._id} value={el._id}>{el.nome}</option>
                                ))}
                            </select>
                        ) : filtro.tipo === "Portaria" ? (
                            <input type="number" className="input" name="filtroOpcao" style={{ width: mediaWeb ? "20vw" : "50vw" }}
                                placeholder="Ex.: 01" onChange={(e) => updateFiltroOpcao(index, e.target.value)} />
                        ) : filtro.tipo === "Pessoas" ? (
                            <select
                                name="filtroOpcao"
                                className="input" style={{ width: mediaWeb ? "20vw" : "50vw" }}
                                onChange={(e) => updateFiltroOpcao(index, e.target.value)}
                            >
                                <option value=""></option>
                                {users.map(u => (
                                    <option key={`opcao-${u._id}`} value={u.nome}>
                                        {u.nome}
                                    </option>
                                ))}
                            </select>
                        ) : filtro.tipo === "Situação" ? (
                            <select
                                name="filtroOpcao"
                                className="input" style={{ width: mediaWeb ? "20vw" : "50vw" }}
                                onChange={(e) => updateFiltroOpcao(index, e.target.value)}
                            >
                                <option value=""></option>
                                <option value="Arquivo">Arquivo</option>
                                <option value="Presidência">Presidência</option>
                                <option value="Ações Ajuizadas">Ações Ajuizadas</option>
                                <option value="Procedimentos no MP">Procedimentos no MP</option>
                                <option value="Aguardando Prazo">Aguardando Prazo</option>
                            </select>
                        )
                            // Caso o filtro seja de Data ou Interessados, exibe o input apropriado:
                            : filtro.tipo === "Data" ? (
                                <input
                                    type="month"
                                    className="input"
                                    name="filtroOpcao"
                                    style={{ width: mediaWeb ? "20vw" : "50vw" }}
                                    onChange={(e) => updateFiltroOpcao(index, e.target.value)}
                                />
                            ) : filtro.tipo === "Interessados" ? (
                                <input
                                    type="text"
                                    className="input"
                                    name="filtroOpcao"
                                    placeholder="Digite termo para busca"
                                    style={{ width: mediaWeb ? "20vw" : "50vw" }}
                                    onChange={(e) => updateFiltroOpcao(index, e.target.value)}
                                />
                            ) : (
                                <input type="number" className="input" name="filtroOpcao" style={{ width: mediaWeb ? "20vw" : "50vw" }}
                                    onChange={(e) => updateFiltroOpcao(index, e.target.value)} />
                            )}
                    </div>
                ))}
            </div>
            {loading ? (
                <p>Carregando...</p>
            ) : (
                <>
                    <div style={{ position: mediaWeb ? "relative" : null, overflowX: mediaWeb ? null : "auto" }}>
                        <table className='tableJuridico' style={{ width: mediaWeb ? null : "150vw" }}>
                            <thead>
                                <tr>
                                    <th className='thJuridico'>Tipo</th>
                                    <th className='thJuridico'>Número</th>
                                    <th className='thJuridico'>Data de Criação</th>
                                    <th className='thJuridico' style={{ width: "20vw" }}>Interessados</th>
                                    <th className='thJuridico'>Responsável</th>
                                    <th className='thJuridico'>Setor/Usuário</th>
                                    <th className='thJuridico'></th>
                                    {localStorage.matriculaJ === "bruno.barros" ||
                                        localStorage.matriculaJ === "carlos.francisco" ||
                                        localStorage.matriculaJ === "nelson.modesto" ? (
                                        <th className='thJuridico'></th>
                                    ) : (<></>)}
                                </tr>
                            </thead>
                            <tbody>
                                {processos.map((processo, index) => (
                                    <tr key={index}>
                                        <td className='tdJuridico'>{processo.tipo}</td>
                                        <td className='tdJuridico'>{processo.numero}/{processo.dataCriacao.slice(0, 4)}</td>
                                        <td className='tdJuridico'>{converterData(processo.dataCriacao.slice(0, 10))}</td>
                                        <td className='tdJuridico'>
                                            {processo.interessados.map(el => {
                                                console.log(el)
                                                return (
                                                    <div>{el.nome || el.razaoSocial}
                                                        <br></br>
                                                        <br></br>
                                                    </div>
                                                )
                                            })}
                                        </td>
                                        <td className='tdJuridico'>{processo.responsavel}</td>
                                        <td className='tdJuridico'>
                                            {processo?.setor === "Aguardando Prazo"
                                                ? `Aguardando Prazo(${converterData(processo.prazo?.slice(0, 10))}) - ${processo.destinoPrazo}`
                                                : processo?.setor || "Não foi dado Despacho"}
                                        </td>
                                        <td className='tdJuridico' style={{ textAlign: "center" }}>
                                            <button className="botaoNPed" onClick={e => window.location = `/juridico/processo/${processo._id}`}
                                                style={{ width: mediaWeb ? null : "20vw" }}>Abrir</button>
                                        </td>
                                        {localStorage.matriculaJ === "bruno.barros" ||
                                            localStorage.matriculaJ === "carlos.francisco" ||
                                            localStorage.matriculaJ === "nelson.modesto" ? (
                                            <td className='tdJuridico' style={{ textAlign: "center" }}>
                                                <button className="botaoNPed" onClick={() => excluirProcesso(processo._id)}
                                                    style={{ width: mediaWeb ? null : "20vw", backgroundColor: "red" }}>Excluir</button>
                                            </td>
                                        ) : (<></>)}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </>
    )
}

export default BuscaProcesso
